export default __webpack_public_path__ + "static/media/add-goal.b48177c4.svg";